<template>
  <div class="uni-empty">
    <img
      class="empty-img"
      :class="imgClass"
      src="../assets/images/empty.png"
      alt=""
    />
    <p class="p1">{{ title }}</p>
    <p class="p2">{{ tips }}</p>
  </div>
</template>

<script>
export default {
  name: "ComponentEmpty",
  props: {
    title: {
      type: String,
      default: "对不起，您暂时还不能参加考前集训",
    },
    tips: {
      type: String,
      default: "参见考前集训前，请完成考试报名，否则不能进行考前集训",
    },
    imgClass: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.uni-empty {
  padding-top: 100px;
  padding-bottom: 100px;
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-img {
    width: 211px;
  }

  .p1 {
    margin-top: 20px;
    font-size: 16px;
    color: #999;
  }

  .p2 {
    margin-top: 10px;
    color: #9a9a9a;
  }
}
</style>
